import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  UserState,
  FetchUsersResponse,
  FetchUserByIdResponse,
  FetchAllUsersResponse,
  ActivateUsersExceptResponse,
  SuspendUsersExceptResponse,
} from './types'
import {
  fetchUserById,
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
  suspendUser,
  activateUser,
  fetchAllUsers,
  activateUsersExcept,
  suspendUsersExcept,
} from './service'

const initialState: UserState = {
  userForEdit: null,
  total: 0,
  totalPages: 0,
  users: [],
  listLoading: false,
  actionLoading: false,
  error: null,
}
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUsers: (state: UserState) => {
      state.users = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state: UserState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchUsers.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchUsers.fulfilled,
      (state: UserState, action: PayloadAction<FetchUsersResponse>) => {
        state.listLoading = false
        state.error = null
        const {users, total, totalPages} = action.payload
        state.users = users
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllUsers.pending, (state) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchAllUsers.rejected, (state, action: PayloadAction<any>) => {
      state.listLoading = false
      state.error = 'error'
    })
    builder.addCase(
      fetchAllUsers.fulfilled,
      (state, action: PayloadAction<FetchAllUsersResponse>) => {
        state.users = action.payload.users
        state.listLoading = false
        state.error = null
      }
    )

    builder.addCase(fetchUserById.pending, (state: UserState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchUserById.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchUserById.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.listLoading = false
        state.error = null
        state.userForEdit = action.payload.user
      }
    )

    builder.addCase(createUser.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createUser.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createUser.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateUser.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateUser.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateUser.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteUser.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteUser.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteUser.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendUser.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendUser.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendUser.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateUser.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(activateUser.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      activateUser.fulfilled,
      (state: UserState, action: PayloadAction<FetchUserByIdResponse>) => {
        state.userForEdit = action.payload.user
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateUsersExcept.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      activateUsersExcept.rejected,
      (state: UserState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      activateUsersExcept.fulfilled,
      (state: UserState, action: PayloadAction<ActivateUsersExceptResponse>) => {
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendUsersExcept.pending, (state: UserState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendUsersExcept.rejected, (state: UserState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendUsersExcept.fulfilled,
      (state: UserState, action: PayloadAction<SuspendUsersExceptResponse>) => {
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default userSlice.reducer
export const actions = userSlice.actions
